import { PCDAlignment } from '@editor/interfaces/inspection'

import { ERROR_PROCESS, processErrorHandler } from './ErrorHandler'
import { GET_RPOJECTS_API_URL } from './Projects'

/**
 * Saves a PCD alignment.
 *
 * @param accessToken Access token
 * @param projectId Project ID
 * @param params PCD alignment parameters
 */
export const postPCDAlignment = async (accessToken: string, projectId: string, params: PCDAlignment) =>
  fetch(`${GET_RPOJECTS_API_URL(projectId)}/pcd-alignments`, {
    method: 'POST',
    headers: {
      responseType: 'json',
      'X-Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify(params),
  })

/**
 * Deletes a PCD alignment.
 * @param accessToken Access token
 * @param projectId Project ID
 * @param inspection_area_ids Pair of inspection area IDs to delete.
 * @returns
 */
export const deletePCDAlignment = async (
  accessToken: string,
  projectId: string,
  inspection_area_ids: [string, string],
  showErrorModal: (message: string) => void,
) =>
  fetch(`${GET_RPOJECTS_API_URL(projectId)}/pcd-alignments`, {
    method: 'DELETE',
    headers: {
      responseType: 'json',
      'X-Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ inspection_area_ids }),
  }).catch((err) => {
    processErrorHandler(err, ERROR_PROCESS.PCD_ALIGNMENT, showErrorModal)
    return null
  })
